import { DB, ExecuteResult } from "./index";
import time from "../time";

const upsert_sql =
    "insert into t_group_summary(" +
    " tid, uid, name, name_py, name_pys," +
    " tag, tagid, avatar, remark, ctime, lutime," +
    " lctime" +
    " ) values (" +
    " ?, ?, ?, ?, ?," +
    " ?, ?, ?, ?, ?," +
    " ?, ?" +
    " ) ON CONFLICT(tid) DO UPDATE SET" +
    " uid = ?, name = ?, name_py = ?, name_pys = ?," +
    " tag = ?, tagid = ?, avatar = ?,  remark = ?, ctime = ?, lutime = ?";

export async function group_summary_upsert(db: DB, groupSum: GroupSummary): Promise<ExecuteResult> {
    const d = GroupToEntity(fixGroupSummary(groupSum));
    d.lutime = time.toUnixMillSecond(time.now());
    d.lctime = d.lutime;
    const params = [];
    // INSERT
    params.push(...[d.tid, d.uid, d.name, d.name_py, d.name_pys]);
    params.push(...[d.tag, d.tagid, d.avatar, d.remark, d.ctime, d.lutime]);
    params.push(...[d.lctime]);
    // UPDATE
    params.push(...[d.uid, d.name, d.name_py, d.name_pys]);
    params.push(...[d.tag, d.tagid, d.avatar, d.remark, d.ctime, d.lutime]);
    return await db.Execute(upsert_sql, params);
}
export async function group_summary_del(db: DB, tid: string): Promise<ExecuteResult> {
    const sql = `delete from t_group_summary where tid = ?`;

    return await db.Execute(sql, [tid]);
}

export async function group_summary_query_all(db: DB): Promise<{ error: any; groupSummarys?: GroupSummary[] }> {
    const sql = "select * from t_group_summary";
    const r = await db.Query(sql, []);
    if (r.error) {
        return { error: r.error };
    }
    if (!(r.data && r.data.length > 0)) {
        return { error: null };
    }
    const d = r.data as Entity[];
    const n = d.length;
    const gs = [];
    for (let i = 0; i < n; i++) {
        gs.push(EntityToGroup(d[i]));
    }
    return { error: null, groupSummarys: gs };
}
export async function group_summary_query_by_tid(db: DB, tid: string): Promise<{ error: any; groupSummary?: GroupSummary }> {
    const sql = "select * from t_group_summary where tid = ?";
    const r = await db.Query(sql, [tid]);
    if (r.error) {
        return { error: r.error };
    }
    if (!(r.data && r.data.length > 0)) {
        return { error: null };
    }
    const d = r.data as Entity[];
    if (d.length > 0) {
        return { error: null, groupSummary: EntityToGroup(d[0]) };
    }
    return { error: null };
}

export type GroupSummaryUpdateType = {
    name?: string;
    avatar?: string;
    remark?: string;
};

export async function group_summary_update(db: DB, tid: string, data: GroupSummaryUpdateType): Promise<{ error: any }> {
    const updates: string[] = [];
    const params: any[] = [];

    if (data.name != null) {
        updates.push("name = ?");
        params.push(data.name);
    }
    if (data.avatar != null) {
        updates.push("avatar = ?");
        params.push(data.avatar);
    }
    if (data.remark != null) {
        updates.push("remark = ?");
        params.push(data.remark);
    }

    if (updates.length === 0) {
        return { error: 1 }; // 没有字段需要更新
    }

    const sql = `
    UPDATE t_group_summary
    SET ${updates.join(", ")}
    WHERE tid = ?
  `;
    params.push(tid);

    const r = await db.Execute(sql, params);
    if (r.rowsAffected > 0) {
        return { error: 0 };
    }
    return { error: null };
}

function GroupToEntity(a: GroupSummary): Entity {
    return {
        tid: a.tid, // 会话Id
        uid: a.uid, // 创建人 群主
        name: a.name, // 群名
        name_py: a.namePY, // 群名 拼音
        name_pys: a.namePYS, // 群名 拼音首字母
        tag: a.tag, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
        tagid: a.tagid, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
        ctime: a.ctime, // 创建时间
        avatar: a.avatar,
        remark: a.remark,
        lutime: a.lutime,
        lctime: a.lctime,
    };
}

function EntityToGroup(a: Entity): GroupSummary {
    return {
        tid: a.tid, // 会话Id
        uid: a.uid, // 创建人 群主
        name: a.name, // 群名
        namePY: a.name_py, // 群名 拼音
        namePYS: a.name_pys, // 群名 拼音首字母
        tag: a.tag, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
        tagid: a.tagid, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
        ctime: a.ctime, // 创建时间
        avatar: a.avatar,
        remark: a.remark,
        lutime: a.lutime,
        lctime: a.lctime,
    };
}

function fixGroupSummary(a: GroupSummary): GroupSummary {
    return Object.assign({}, defaultGroupSummary, a);
}

export type GroupSummary = {
    tid: string; // 会话Id
    uid: number; // 创建人 群主
    name: string; // 群名
    namePY: string; // 群名 拼音
    namePYS: string; // 群名 拼音首字母
    avatar: string; //
    remark: string; //
    tag: string; // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    tagid: number; // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    ctime: number; // 创建时间
    lutime: number; // 本地 数据最后更新时间
    lctime: number; // 本地 数据最早创建时间
};

const defaultGroupSummary: GroupSummary = {
    tid: "", // 会话Id
    uid: 0, // 创建人 群主
    name: "", // 群名
    namePY: "", // 群名 拼音
    namePYS: "", // 群名 拼音首字母
    tag: "", // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    tagid: -1, // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    ctime: 0, // 创建时间
    avatar: "",
    remark: "",
    lutime: 0,
    lctime: 0,
};

type Entity = {
    tid: string; // 会话Id
    uid: number; // 创建人 群主
    name: string; // 群名
    name_py: string; // 群名 拼音
    name_pys: string; // 群名 拼音首字母
    tag: string; // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    tagid: number; // 群标签  0 - 内部群 1-企业群 2-供应商 3-服务商 4-供应链
    ctime: number; // 创建时间
    avatar: string;
    remark: string;
    //本地
    lutime: number;
    lctime: number;
};
